import { createSlice } from '@reduxjs/toolkit';
import { ApiOrganisation } from '../api';

export interface OrganisationState {
  organisations: ApiOrganisation[];
  page: number;
  size: number;
  total: number;
}

const initialState: OrganisationState = {
  organisations: [],
  page: 0,
  size: 20,
  total: 0,
};

const organisationSlice = createSlice({
  name: 'organisation',
  initialState,
  reducers: {
    fetchOrganisationsSuccess: (state, action) => {
      state.organisations = action.payload.content;
      state.total = action.payload.total;
      state.page = action.payload.number;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = organisationSlice;
// Extract and export each action creator by name
export const { fetchOrganisationsSuccess } = actions;
// Export the reducer, either as a default or named export
export default reducer;
